import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "antd";

import * as Icons from "assets/icons";
import cls from "./Collapse.module.scss";

const Collapse = ({ order, name, steps = [] }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className={cls.wrapper} onClick={() => setOpen(true)}>
        <div className={cls.head}>
          <div>
            <Icons.CheckDone />
          </div>

          <div className={cls.headName}>
            {order} - {t("stage_step")}: {name}
          </div>

          <div className={cls.headIcon}>
            <Icons.Plus />
          </div>
        </div>
      </div>

      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        title={
          <div className={cls.modalTitle}>
            <span
              className={
                cls.modalTitleOrder
              }>{`${order} - ${t("stage_step")}: `}</span>
            <span className={cls.modalTitleName}>{name}</span>
          </div>
        }
        width={700}>
        <div className={cls.modalBody}>
          {steps.length ? (
            steps
              .sort((a, b) => a.order_number - b.order_number)
              .map((step) => (
                <div key={step.id || step.order_number} className={cls.step}>
                  <div className={cls.stepData}>
                    <div className={cls.itemKey}>
                      {step.order_number} - {t("step_name")}:
                    </div>
                    <div className={cls.itemValue}>{step.name}</div>
                  </div>

                  <div className={cls.stepData}>
                    <div className={cls.itemKey}>{t("description")}:</div>
                    <div className={cls.itemValue}>{step.description}</div>
                  </div>

                  {step.department?.name && (
                    <div className={cls.stepData}>
                      <div className={cls.itemKey}>
                        {t("field_department")}:
                      </div>
                      <div className={cls.itemValue}>
                        {step.department?.name}
                      </div>
                    </div>
                  )}

                  {step.position?.name && (
                    <div className={cls.stepData}>
                      <div className={cls.itemKey}>{t("field_position")}:</div>
                      <div className={cls.itemValue}>{step.position?.name}</div>
                    </div>
                  )}

                  <div className={cls.stepData}>
                    <div className={cls.itemKey}>
                      {t("field_digitization_status")}:
                    </div>
                    <div className={cls.itemValue}>
                      {t(step.digitizationStatus)}
                    </div>
                  </div>
                </div>
              ))
          ) : (
            <div className={cls.noSteps}>{t("NO_CONTENT")}</div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default Collapse;
